export const ERROR_TITLES = {
  'file-invalid-type': () => `Не все файлы были загружены`,
  'file-too-large': (count: number) => `${count > 1 ? 'Файлы' : 'Файл'} слишком большого размера`,
  'too-many-files': () => `Не все файлы были загружены`,
};

export const ERROR_CONTENS = (acceptedFiles, maxFileSizeMB, maxFiles) => {
  return {
    'file-invalid-type': (fileList: string[]) =>
      `${fileList.length > 1 ? 'Файлы' : 'Файл'} ${fileList.map(
        (f, i) => `${f}${i + 1 === fileList.length ? '' : ','}`,
      )} не загружен${fileList.length > 1 ? 'ы' : ''}. Форматы доступные для загрузки: ${acceptedFiles}`,
    'file-too-large': (fileList: string[]) =>
      `${fileList.length > 1 ? 'Файлы' : 'Файл'} ${fileList.map(
        (f, i) => `${f}${i + 1 === fileList.length ? '' : ','}`,
      )} не загружен${fileList.length > 1 ? 'ы' : ''}. Максимальный размер файла ${maxFileSizeMB} Мб.`,
    'too-many-files': () => `Превышен лимит в ${maxFiles} файлов на единоразовую загрузку`,
  };
};
